import { useField } from 'formik';
import propTypes from 'prop-types';
import React, { useEffect } from 'react';
import { Stack, Typography } from '@mui/material';
import ReactionOutputs from '../../reaction-outputs/ReactionOutputs';
import StepBackBone, { useStepperController } from './step-backbone';
import { useTranslation } from 'react-i18next';

export default function ChooseReactions({ namespace }) {
  const { t } = useTranslation();
  const { setNextButtonDisabled } = useStepperController();
  const [field, meta] = useField(namespace + '.o');

  useEffect(() => {
      setNextButtonDisabled(meta.error);
  }, [meta.error, setNextButtonDisabled]);

  return (
    <StepBackBone>
      <Stack spacing={2}>
        <Typography variant='body2' color='text.secondary'>
          {t('MOVE_CONF.REACTION_HELP')}
        </Typography>
        <ReactionOutputs namespace={namespace + '.o'} />
      </Stack>
    </StepBackBone>
  );
}

ChooseReactions.propTypes = {
  namespace: propTypes.string,
}